<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12" md="4" class="mb-3">
                <b-card>
                    <div class="d-flex">
                        <div>Disponibilità</div>
                        <div class="ml-auto">{{availability}}</div>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
                <b-card>
                    <div class="d-flex">
                        <div>Autorizzati</div>
                        <div class="ml-auto">{{authorized}}</div>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
                <b-card :border-variant="errorToAdd ? 'danger' : ''">
                    <div class="d-flex">
                        <div>Selezionati</div>
                        <div class="ml-auto">
                            {{selected.length}}
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="list-contacts">
            <b-col v-for="(contact, index) in contacts" v-bind:key="index"
                   cols="12" md="6" class="mb-2">
                <div class="d-flex">
                    <div class="text-uppercase" v-bind:class="contact.selected ? 'text-primary' : ''">
                        {{contact.surname}} {{contact.name}}
                    </div>
                    <div class="ml-auto">
                        <b-form-checkbox v-model="contact.selected" switch>
                        </b-form-checkbox>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import _ from "lodash";

    export default {
        name: "SocietyMatchesAddContactContainer",
        props: {
            contacts: {
                type: Array,
                default: () => []
            },
            mode: {
                type: String,
                default: 'junior'
            },
            availability: {
                type: Number,
                default: 0
            },
            juniorAuthorized: {
                type: Number,
                default: 0
            },
        },
        computed: {
            authorized: function () {
                if (this.mode !== 'junior') {
                    return Math.abs(this.juniorAuthorized);
                } else {
                    return this.availability;
                }
            },
            selected: function () {
                return _.filter(this.contacts, (item) => {
                    return item.selected;
                });
            },
            errorToAdd: function () {
                return this.selected.length > this.authorized;
            }
        },
        methods:{
            validate: function() {
                return !this.errorToAdd;
            }
        }
    }
</script>

<style scoped lang="scss">

    .list-contacts {
        min-height: 150px;
        max-height: 350px;
        overflow: auto;
    }

</style>
